import { Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as T from '../Typography';
import * as S from './style';

import Modal from '../Modal';
import docIcon from '../assets/doc.svg';
import { routes } from '../../constants';
import colors from '../../theme/colors';
import { CloseRounded } from '@mui/icons-material';
import { ControllerCheckbox } from '../Inputs/Checkbox';
import { confirmDownloadSurvey } from '../../validation/schemas';
import Button from '../Button';
import { supportEmail } from '../../constants/external';

const DownloadSurveyConfirmModal = ({ visible, setIsModalVisible }) => {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(confirmDownloadSurvey)
  });

  return (
    <Modal
      visible={visible}
      setIsModalVisible={setIsModalVisible}
      bgColor="white"
    >
      <form
        onSubmit={handleSubmit(() => {
          setIsModalVisible();
          window.open(
           'https://www.socialmobility.org.uk/employerindex-resources#:~:text=Employer%20Index%20Survey%20%2D%20Word%20Version',
           '_blank'
          );
        })}
      >
        <Box
          textAlign={'right'}
          display={'flex'}
          justifyContent={'flex-end'}
          width={'100%'}
          pt={1}
          pr={1}
        >
          <CloseRounded
            sx={{ width: 24, height: 24, cursor: 'pointer' }}
            htmlColor={colors.neutral.shades.shade700}
            onClick={setIsModalVisible}
          />
        </Box>
        <Box textAlign={'left'} p={4} pt={0}>
          <Box mb={4}>
            <Box mb={3}>
              <img src={docIcon} />
            </Box>
            <T.H18px mb={4}>Download survey for offline viewing</T.H18px>
            <T.TextSmallRegular color={colors.neutral.shades.shade600}>
              You can complete the survey offline, but remember you'll need to submit your responses online to enter.
            </T.TextSmallRegular>
          </Box>
          <S.ContentContainer p={4}>
            <T.TextSmallBold>Download and fill out the survey:</T.TextSmallBold>
            <T.TextSmallRegular mb={4}>
              Use Microsoft Word to view and fill out the survey at your own pace.
            </T.TextSmallRegular>
            <T.TextSmallBold>Save your responses securely:</T.TextSmallBold>
            <T.TextSmallRegular mb={4}>
              Ensure you save a copy of your responses as you fill out the document.
            </T.TextSmallRegular>
            <T.TextSmallBold>Return to submit online:</T.TextSmallBold>
            <T.TextSmallRegular mb={6}>
              To officially submit your answers, please return to this dashboard and complete the survey online before the deadline.
            </T.TextSmallRegular>
            <T.TextSmallRegular>
              If you have any questions or need a hand, please
              contact support at{' '}
              <T.Link
                to={`mailto:${supportEmail}`}
                color={colors.blue.shades.shade700}
                weight={'bold'}
              >
                {supportEmail}
              </T.Link>{' '}
              or{' '}
              <T.Link
                to={routes.FAQ}
                color={colors.blue.shades.shade700}
                weight={'bold'}
                target="_blank"
              >
                visit the FAQs
              </T.Link>.
            </T.TextSmallRegular>
          </S.ContentContainer>
          <ControllerCheckbox
            control={control}
            name="confirmDownload"
            label="I understand that I must complete the survey online to officially enter the Index."
          />
          {errors.confirmDownload && (
            <T.TextSmallRegular color={colors.red.shades.shade700}>
              Please tick the box above before downloading.
            </T.TextSmallRegular>
          )}
          <Box mt={1}>
            <Button
              variant="blue"
              decoration="none"
              width={'fit-content'}
              type="submit"
            >
              Download survey
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  );
};

export default DownloadSurveyConfirmModal;
